import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import registered from './registered';
import all from './all';

const Kyc = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/registered`}/>
      <Route path={`${match.url}/registered`} component={registered}/>
      <Route path={`${match.url}/all`} component={all}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default Kyc;
